'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTrackingParams = setTrackingParams;
exports.getTrackingParams = getTrackingParams;

var _localStorage = require('utils/localStorage');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setTrackingParams(urlQuery) {
  // Store all utm_ and aff_ params if any
  var trackingParams = urlQuery.toLowerCase().replace('?', '').split('&').map(function (t) {
    return t.trim();
  }).filter(function (t) {
    return t.indexOf('utm_') >= 0 || t.indexOf('aff_') >= 0;
  });
  // console.log(`trackingParams = ${JSON.stringify(trackingParams)}`);
  (0, _localStorage.localStore)().set('trackingParams', trackingParams.join('&'));
  (0, _localStorage.localStore)().set('trackingParamsUpdatedAt', new Date());
}

function formatParams(arrParams) {
  var objParams = {};
  arrParams.split('&').forEach(function (p) {
    var pp = p.split('=');
    if (pp.length === 2) {
      objParams[pp[0]] = pp[1];
    }
  });
  return objParams;
}

function getTrackingParams() {
  try {
    var now = (0, _moment2.default)(new Date());
    var updatedAt = (0, _moment2.default)((0, _localStorage.localStore)().get('trackingParamsUpdatedAt'));
    var duration = _moment2.default.duration(now.diff(updatedAt));
    if (Math.abs(duration.asDays()) >= 3) {
      // We keep tracking params for only 3 days, after that it will be cleared
      (0, _localStorage.localStore)().clear('trackingParams');
      (0, _localStorage.localStore)().clear('trackingParamsUpdatedAt');
      return [];
    }
    return formatParams((0, _localStorage.localStore)().get('trackingParams') || '');
  } catch (error) {
    console.log('Failed to get tracking params!');
    return [];
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/CampaignTracking.js
// module id = 727
// module chunks = 0